<template>
<div id="cafe_out">
    <div id="popup_wrap">
        <div class="popup-cont01">
            <div class="login_bg" :style="{backgroundImage: 'url(' + store_bg_image + ')', backgroundSize: '100%'}">
                <div class="logo" v-bind:style="{width: logo_width_size+'px' , height: logo_height_size+'px'}"><img :src="store_main_image" /></div>
                <div class="main-content">
                    <div class="input-tag">
                    <form id="user_login" action="action/user_login.php" method="post">
                        <input type="text" class="input-touch" v-model="user_id" ref='user_id' v-on:focus='inputFocus("user_id")' autocomplete="off" full_length="13" name="user_hp" value="010" placeholder="휴대폰번호">
                        <input type="password" class="input-touch" full_length="4" name="user_password" v-model="user_password" ref='user_password' v-on:focus='inputFocus("user_password")' autocomplete="off" placeholder="비밀번호">
                    </form>
                    </div>
                    <div class="btn-tag">
                        <div class="sub-btn">
                            <template v-if="page_type === 're_entry'">
                                <span id="open_door" @click="re_entry">재입장하기</span>
                                <span id="cancel2" @click="back_btn">취소</span>
                            </template>
                            <template v-else>
                                <span id="out_login" @click="seat_out">퇴실하기</span>
                                <span id="cancel2" @click="back_btn">취소</span>
                            </template>
                        </div>
                    </div>
                </div>
                <num-pad v-bind:parent_key_str="parent_key_str" v-bind:key_type_str="current_focus.type" v-on:numClick="numPadInput"></num-pad>
                <!-- <div id="popup_pw" @click="change_pwd" class="pw_btn">비밀번호 재설정</div> -->
            </div>
        </div>
    </div>
</div>
<!-- <modals-container /> -->
</template>

<script>
const FOCUS_TYPE = {
    ID: {
        name: 'user_id',
        type: 'PHONE'
    },
    PASS: {
        name: 'user_password',
        type: 'PASSWORD'
    },
}

import numPad from '../components/num-pad';
import moment from 'vue-moment';

// 사용자 정의 모듈.
import * as config from '../../javascript/config';
import axios from 'axios';
import vue from 'vue';
vue.use(moment);
vue.component('num-pad', numPad);
import * as appVue from '../../App.vue'

export default {
    name: 'Main',
    data() {
        return {
            flag: true,
            user_id: '',
            user_password: '',
            current_focus: FOCUS_TYPE.ID,
            parent_key_str: '',
            page_type : '',
            store_main_image : '',
            logo_width_size: 0,
            logo_height_size: 0,
            store_bg_image:'',
        }
    },
    methods: {
        inputFocus: function (type) {
            this.current_focus = type == FOCUS_TYPE.ID.name ? FOCUS_TYPE.ID : FOCUS_TYPE.PASS;
            if (this.current_focus === FOCUS_TYPE.ID) {
                this.parent_key_str = this.user_id;
            } else if (this.current_focus === FOCUS_TYPE.PASS) {
                this.parent_key_str = this.user_password;
            }
        },
        numPadInput: function (numberStr, overMaxLength) {
            // num-pad에 넘겨줄 값 변경.
            this.parent_key_str = numberStr;

            if (this.current_focus === FOCUS_TYPE.ID) {
                // hp
                this.user_id = numberStr;

                // set focus
                if (overMaxLength) {
                    this.$refs.user_password.focus();
                } else this.$refs.user_id.focus();
            } else if (this.current_focus === FOCUS_TYPE.PASS) {
                // password
                this.user_password = numberStr;
                // set focus
                if (!overMaxLength) this.$refs.user_password.focus();
                // else this.current_focus = null;
            }
        },
        register_modal_pop() {
            var router = this.$router;
            router.push('/register') // 이동 위치를 입력
        },
        change_pwd(){
            var router = this.$router;
            router.push('/password_edit') // 이동 위치를 입력
        },
        back_btn(){
            this.$store.commit('set_cafe_out_page_type', {
                'page_type': ''
            });
            this.$router.go(-1);
        },
        // 퇴실하기
        seat_out(){
            const type = config.REQ_SEAT_USE_GET_CHECK;
            let data = new Object;
            if(this.user_id == "" || this.user_password == ""){
                this.popup_message("휴대폰번호와 비밀번호를 입력해주세요");
                return false;
            }
            data.user_hp = this.user_id;
            data.password = this.user_password;
            this.$store.dispatch(type.action_name, {
                type: type,
                data: data
                // }).then(function (response) { // => this.$store를 인식하지 못하는 문제로 아래 코드 사용.
            }).then((response) => {
                if(response.message === 'suc'){
                    const out_type = config.REQ_SEAT_USE_DELETE;
                    let out_data = new Object;
                    let obj = new Object;
                    obj.user_id = response.data.user_id;
                    obj.seat_use_id = response.data.seat_use_id;
                    out_data.data = obj;
                    this.$store.dispatch(type.action_name, {
                        type: out_type,
                        data: out_data
                    }).then((response) => {
                        this.popup_message(`퇴실 처리가 완료되었습니다.`);
                        this.$router.push('/start');
                        let self = this;
                        setTimeout(function(){self.$store.commit('set_reset_popup_type')}, 3000);
                    })
                }else if(response.message === 'fail'){
                    this.popup_message(`사용 중인 좌석이 없습니다.`);
                }else if(response.message === 'password_fail'){
                    this.popup_message(`비밀번호가 일치하지 않습니다.</span><br /><br /><span>확인 후 재시도 바랍니다.`);
                }else if(response.message === 'not_user'){
                    this.popup_message(`존재하지 않는 회원입니다.`);
                }
            }).catch(function (error) {
                console.log('error=============>', error);
            });
        },
        re_entry(){
            let self = this;

            if(this.user_id == "" || this.user_password == ""){
                this.popup_message("휴대폰번호와 비밀번호를 입력해주세요");
                return false;
            }
            // 로그인하기
            const type = config.REQ_MEMBER_LOGIN;
            const data = {
                data: {
                    'user_hp': this.user_id,
                    'password': this.user_password
                }
            };
            this.$store.dispatch(type.action_name, {
                type: type,
                data: data
            }).then((response) => {
                let tid_array = {};

                if (response.result && response.data.blacklist_yn != 1) {
                    this.$store.commit('set_user', {
                        user: response.data
                    });
                    let user_data = {store_id: response.data.store_id, user_id: response.data.user_id};

                    // 로그인 후 이용중인 좌석 가져오기 (개인석)
                    this.$store.dispatch(config.REQ_DOOR_SINGLE_GET.action_name, {
                        type: config.REQ_DOOR_SINGLE_GET,
                        data: user_data
                    }).then(response => {
                        let tmp_data = response.data.contents;
                        tmp_data.forEach(function(item, idx){
                            let tid = item.tid;
                            if(tid_array[item.tid] == undefined){
                                tid_array[item.tid] = {
                                    tid : item.tid,
                                    name : item.door_group_name,
                                    kind : item.controller_kind,
                                    endDate : item.use_end_datetime
                                }
                            }
                        });
                        this.user_id = '010-';
                        this.user_password = '';
                    }).catch(function (error) {
                        console.log('error=============>', error);
                    });

                    // 로그인 후 이용중인 좌석 가져오기 (단체석)
                    this.$store.dispatch(config.REQ_DOOR_GROUP_GET.action_name, {
                        type: config.REQ_DOOR_GROUP_GET,
                        data: user_data
                    }).then(response => {
                        let tmp_data = response.data.contents;
                        tmp_data.forEach(function(item, idx){
                            let tid = item.tid;
                            if(tid_array[item.tid] == undefined){
                                tid_array[item.tid] = {
                                    tid : item.tid,
                                    name : item.door_group_name,
                                    kind : item.controller_kind,
                                    endDate : item.use_end_datetime
                                }
                            }
                        });
                        if(Object.keys(tid_array).length > 0){
                            self.$store.commit('set_door_kind_list', tid_array);
                            if(Object.keys(tid_array).length > 1){
                                const alert_param = {
                                    code: this.$store.getters['get_popup_code'].POPUP_DOOR_KIND_LIST
                                };
                                self.$store.commit('set_popup_type', alert_param);
                            }else{
                                this.doorOpen(Object.keys(tid_array)[0]);
                            }
                        }else{
                            const alert_param = {
                                code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                                message: '이용중인 좌석이 없습니다.',
                            };
                            this.$store.commit('set_popup_type', alert_param);
                        }
                    }).catch(function (error) {
                        console.log('error=============>', error);
                    });
                } else {
                    // 로그인 실패
                    this.user_id = '';
                    this.user_password = '';

                    let message = `휴대폰번호, 비밀번호가 일치하지 않습니다.</span><br /><br /><span>확인 후 재시도 바랍니다.`;
                    if (response.data.blacklist_yn == 1) message = `이용제한 사용자 입니다.</span><br /><br /><span>관리자에게 문의하세요.`;
                    this.popup_message(message);
                    return Promise.reject();
                }
            }).catch(function (error) {
                console.log('error=============>', error);
            });
        },
        doorOpen(tid){
            let data = this.$store.getters["get_door_kind_list"][tid];
            let urlString = '';

            switch(data.kind){
                case "0":
                    urlString = "/door/CNC?tid=" + data.tid;
                    break;
                case "1":
                    urlString = "/door/IS?tid=" + data.tid;
                    break;
            }

            axios.get(urlString).then(result =>{
                let textString = '';
                switch(result.data.res){
                    case "none":
                        textString = "코드 오류 - 관리자 문의";
                        break;
                    case "error":
                        textString = "컨트롤러 오류 - 관리자 문의";
                        break;
                    case "open":
                        textString = "자동문이 정상적으로 열렸습니다.";
                        break;
                }
                const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                    message: textString,
                    router: null,
                };
                this.$store.commit('set_popup_type', alert_param);
                this.$router.push("/start");

                let self = this;
                setTimeout(function(){self.$store.commit('set_reset_popup_type')}, 3000);
            });
        },
        popup_message(message){
            const alert_param = {
                code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                message: message,
                router: '/cafe_out',
            };
            this.$store.commit('set_popup_type', alert_param);
        }
    },
    mounted() {
        // 스토어 로고 이미지
        var temp_store_main_image = this.$store.getters['getStoreInfo']['store_img'];
        if(typeof temp_store_main_image == 'undefined' || temp_store_main_image == ''){
            temp_store_main_image = config.SYS_HOST+'/images/kiosk/logo/logo.png';
        }else{
            temp_store_main_image = config.SYS_HOST+'/images/kiosk/logo/'+temp_store_main_image;
        }
        this.store_main_image = temp_store_main_image;
        this.logo_width_size = this.$store.getters['getStoreInfo']['logo_width_size'];
        this.logo_height_size = this.$store.getters['getStoreInfo']['logo_height_size'];

        // 로그인 초기값 설정.
        if( process.env.NODE_ENV == 'production' ){
            this.user_id = '010-';
            this.user_password = '';
        } else {
            this.user_id = '010-1234-1234';
            this.user_password = '1234';
        }
        this.page_type = this.$store.getters['get_cafe_out_page_type'];
        this.store_bg_image = this.$store.getters['get_store_bg_img_url'];
    },

}
</script>



// WEBPACK FOOTER //
// src/components/page/cafe_out.vue